const URL = '/cuentas_saldos'
const state = {
  all: [],
  selected: {
    id: null,
    periodo: null,
    consumido: 0,
    subsidio: 0,
    usuario: 0,
    pleno: 0,
    cuenta_id: null,
    created_at: null,
    updated_at: null
  },
  filters: {
    periodo_from: null,
    periodo_to: null,
    cuenta_id: null,
  },
  loading: false,
  headers: [
    {
      text: 'Periodo',
      value: 'periodo',
      align: 'center'
    },
    {
      text: 'Kilos consumidos',
      value: 'consumido',
      align: 'center'
    },
    {
      text: 'Saldo',
      value: 'pleno',
      align: 'center'
    },
  ],
  options: {
    itemsPerPage: 10,
    page: 1,
    sortBy: [],
    sortDesc: []
  },
  itemsLength: null,
}

// GETTERS
const getters = {
  all (state) {
    return state.all
  },
  selected (state) {
    return state.selected
  },
  filters (state) {
    return state.filters
  },
  headers (state) {
    return state.headers
  },
  itemsLength (state) {
    return state.itemsLength
  },
  options (state) {
    return state.options
  },
  loading (state) {
    return state.loading
  },
}

// ACTIONS
const actions = {
  onClearAll ({ commit }) {
    commit('setAll', [])
    commit('setOptions', {
      itemsPerPage: 10,
      page: 1,
      sortBy: [],
      sortDesc: []
    })
  },
  onClearFilters ({ commit }) {
    commit('setFilters', {
      periodo_from: null,
      periodo_to: null,
      cuenta_id: null,
    })
  },
  onClearSelected ({ commit}) {
    commit('setSelected', {
      id: null,
      periodo: null,
      consumido: 0,
      subsidio: 0,
      usuario: 0,
      pleno: 0,
      cuenta_id: null,
      created_at: null,
      updated_at: null
    })
  },
  onFindAll ({ state, commit, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true) // Iniciar carga
      // Usamos 'payload.periodo' si el payload es un objeto con la propiedad 'periodo'.
      // Si 'payload' es directamente el período, solo usa 'payload'.
      // He asumido que 'payload' es el valor directo del período.
      const saldo = state.all.find(item => item.periodo === payload);
      if (saldo) {
        commit('setSelected', saldo);
        resolve(saldo); // Resolver la promesa con el saldo encontrado
      } else {
        dispatch('onClearSelected')
        resolve(null);
        // Si no se encuentra, puedes optar por rechazar la promesa o resolverla con null/undefined.
        // Rechazar es útil si la ausencia de un saldo es un "error" en tu lógica de negocio.
        // Por ejemplo, si siempre esperas encontrar uno.
        // reject(new Error('No se encontró ningún saldo para el período especificado.'));
        // O si quieres que siempre resuelva, incluso si no encuentra:
        // resolve(null);
      }
      commit('setLoading', false); // Finalizar carga, independientemente del resultado
    });
  },
  onFetch ({ state, commit }) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true)
      axios.get(URL, {
        params: {
          itemsPerPage: state.options.itemsPerPage,
          page: state.options.page,
          sortBy: state.options.sortBy[0],
          sortDesc: state.options.sortDesc[0] ? 1 : 0,
          periodo_from: state.filters.periodo_from,
          periodo_to: state.filters.periodo_to,
          cuenta_id: state.filters.cuenta_id,
          export: 0
        }
      })
        .then(response => {
          commit('setAll', response.data.data)
          commit('setItemsLength', response.data.meta.total)
          if (state.options.page + state.options.itemsPerPage > response.data.meta.total)
            commit('setPage', 1)
          resolve(response.data.data)
        })
        .catch(error => {
          reject(error)
        })
        .finally(() => {
          commit('setLoading', false)
        })
    })
  },
  onRefresh ({ state, commit }) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true)
      axios.get(URL + '/' + state.selected.id)
        .then(response => {
          const aux = {
            ...state.selected,
            periodo: response.data.periodo,
            consumido: response.data.consumido,
            subsidio: response.data.subsidio,
            usuario: response.data.usuario,
            pleno: response.data.pleno,
            cuenta_id: response.data.cuenta_id,
            created_at: response.data.created_at,
            updated_at: response.data.updated_at,
          }
          /** Se guarda la información en edited y selected del store Cuentas */
          // commit('setEdited', aux)
          commit('setSelected', aux)
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
        .finally(() => {
          commit('setLoading', false)
        })
    })
  },
}

// MUTATIONS
const mutations = {
  setAll (state, payload) {
    state.all = payload.slice()
  },
  setSelected (state, payload) {
    state.selected = Object.assign({}, payload)
  },
  setFilters (state, payload) {
    state.filters = Object.assign({}, payload)
  },
  setLoading (state, payload) {
    state.loading = payload
  },
  setPage (state, payload) {
    state.options.page = payload
  },
  setItemsPerPage (state, payload) {
    state.options.itemsPerPage = payload
  },
  setItemsLength (state, payload) {
    state.itemsLength = payload
  },
  setOptions (state, payload) {
    state.options = payload
  },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
